import { useTranslation, Trans } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/ui/Dialog';
import { Button } from '@/shared/components/ui/Button';
import { AlertTriangle } from 'lucide-react';

interface ReplaceOpenMeetingDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  employeeName: string;
  onConfirmReplace: () => void;
  isReplacing: boolean;
}

export const ReplaceOpenMeetingDialog = ({
  open,
  onOpenChange,
  employeeName,
  onConfirmReplace,
  isReplacing,
}: ReplaceOpenMeetingDialogProps) => {
  const { t } = useTranslation('oneOnOne');

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size="md">
        <DialogHeader>
          <div className="flex items-start gap-3">
            <div className="rounded-full bg-yellow-100 p-2">
              <AlertTriangle className="h-5 w-5 text-yellow-600" />
            </div>
            <div className="flex-1">
              <DialogTitle>{t('replaceOpenMeeting')}</DialogTitle>
              <DialogDescription className="mt-2">
                <Trans
                  i18nKey="replaceOpenMeetingDescription"
                  ns="oneOnOne"
                  values={{ employeeName }}
                />
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isReplacing}
          >
            {t('cancel')}
          </Button>
          <Button
            onClick={onConfirmReplace}
            disabled={isReplacing}
            variant="default"
          >
            {isReplacing ? (
              <>
                <div className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent me-2" />
                {t('replacing')}
              </>
            ) : (
              t('replaceMeeting')
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
